export default __webpack_public_path__ + "static/media/sdi.59838dc9.png";